__turbopack_context__.v({
  "caption": "Mermaid-module__cG-5ha__caption",
  "diagram": "Mermaid-module__cG-5ha__diagram",
  "diagramFrame": "Mermaid-module__cG-5ha__diagramFrame",
  "loading": "Mermaid-module__cG-5ha__loading",
  "loadingSpinner": "Mermaid-module__cG-5ha__loadingSpinner",
  "mermaidFigure": "Mermaid-module__cG-5ha__mermaidFigure",
  "spin": "Mermaid-module__cG-5ha__spin",
  "textAlternative": "Mermaid-module__cG-5ha__textAlternative",
  "textAlternativeContent": "Mermaid-module__cG-5ha__textAlternativeContent",
  "textAlternativeSummary": "Mermaid-module__cG-5ha__textAlternativeSummary",
});
